<template>
  <action-dispatcher class="view-home" action="courses/getTrails">
    <header v-if="trail" :style="headerStyle">
      <div class="container-fluid text-center">
        <h1 class="mb-4">{{ title }}</h1>
      </div>
    </header>

    <div v-if="trail" class="container-fluid pt-4">
      <action-dispatcher
        action="courses/getLastLessons"
        :parameters="{ trail: trail.id }"
      >
        <h5 v-if="lastLessons.length" class="my-3">
          Continuar assistindo
        </h5>

        <home-carousel :list="progressCourses">
          <template #default="{data:lesson}">
            <progress-course-card class="flex-fill" :lesson="lesson" />
          </template>
        </home-carousel>
      </action-dispatcher>

      <h5 class="my-3">Recomendado</h5>

      <home-carousel
        :list="recommended"
        :per-page-custom="[
          [200, 1.5],
          [400, 2],
          [600, 3],
          [800, 4],
          [1280, 5],
          [1500, 5.5]
        ]"
      >
        <template #default="{data:course}">
          <course-card :course="course" />
          <h6 class="mt-2">{{ course.title }}</h6>
        </template>
      </home-carousel>

      <action-dispatcher
        v-if="trail"
        action="courses/getAllLessons"
        :parameters="{ trail: trail.id }"
      >
        <h5 v-if="lessons.length" class="my-3">
          Últimas aulas adicionadas
        </h5>

        <home-carousel :list="lessons">
          <template #default="{data:lesson}">
            <progress-course-card class="flex-fill" :lesson="lesson" />
          </template>
        </home-carousel>
      </action-dispatcher>
    </div>
  </action-dispatcher>
</template>

<script>
import CourseCard from "@/components/home/CourseCard";
import ProgressCourseCard from "@/components/home/ProgressCourseCard";
import { mapState } from "vuex";
import HomeCarousel from "../components/home/HomeCarousel.vue";

export default {
  components: {
    CourseCard,
    ProgressCourseCard,
    HomeCarousel
  },
  computed: {
    ...mapState("courses", [
      "courses",
      "lastLessons",
      "lessons",
      "course",
      "trails"
    ]),
    trail() {
      return this.trails.find(r => r.id === parseInt(this.$route.params.id));
    },
    headerStyle() {
      if (this.trail && this.trail.background_image) {
        return {
          backgroundImage: `url(${this.trail.background_image})`
        };
      }
      return {};
    },
    title() {
      if (!this.trail?.background_image && !this.trail?.title) {
        return this.trail?.name;
      }
      return this.trail?.title;
    },
    recommended() {
      return this.trail?.courses.map(c =>
        this.courses.find(course => course.id === c)
      );
    },
    progressCourses() {
      return this.lastLessons
        .concat()
        .sort((a, b) => {
          if (a.progress.updated_at > b.progress.updated_at) {
            return -1;
          }
          if (b.progress.updated_at > a.progress.updated_at) {
            return 1;
          }
          return 0;
        })
        .slice(0, 4);
    },
    headerCourse() {
      return this.courses.find(c => c.progress < 100);
    },
    currentLesson() {
      return (
        this.course &&
        this.course.lessons &&
        this.course.lessons.find(
          lesson => !lesson.progress || !lesson.progress.finished_at
        )
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.view-home {
  header {
    background: url("../assets/images/cover.jpg");
    background-size: cover;
    background-position-x: center;
    background-position-y: center;
    position: relative;

    height: 0;
    padding-bottom: 25%;
    width: 100%;

    .container-fluid {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    @media screen and (max-width: 991px) {
      min-height: 400px;
      text-align: center;

      &::before {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        background: linear-gradient(to bottom, transparent 50%, #000b);
      }

      .container-fluid {
        top: unset;
        left: unset;
        transform: unset;
        bottom: 24px;
      }
    }

    img {
      max-width: 100%;
      width: 300px;

      @media screen and (max-width: 991px) {
        width: 150px;
      }
    }
  }

  .text-grey {
    color: #aaa;
  }
}
</style>
